import { RadiusOfOperation } from '../../../../../../../core/constants/radius-of-operation';

/**
 * Mask configurations used in the [mask] directive for the schedule D step two.
 * Documentation: https://imask.js.org/guide.html
 */
export class ScheduleDStepTwoMaskConfig {
    public static readonly groundElevation = {
        mask: Number,
        scale: 1,
        signed: true,
        thousandsSeparator: '',
        padFractionalZeros: false,
        normalizeZeros: true,
        min: -999999.9,
        max: 999999.9,
        radix: '.',
        lazy: false,
    };

    public static readonly radius = {
        mask: Number,
        scale: 1,
        signed: false,
        thousandsSeparator: '',
        padFractionalZeros: false,
        normalizeZeros: true,
        min: RadiusOfOperation.minimum,
        max: RadiusOfOperation.maximum,
        radix: '.',
        lazy: false,
    };
}
